export default __webpack_public_path__ + "static/media/farm.ffbbd09c.png";